import React, { useEffect, useState, useRef } from 'react';
import plantillaTienda from './plantillatienda.json';
import { useNavigate } from 'react-router-dom';
import { useCart } from './CartContext';

const Tiendav3 = () => {
  const navigate = useNavigate();
  const { 
    cart, 
    cartCount, 
    addToCart, 
    removeFromCart, 
    decreaseQuantity, 
    increaseQuantity,
    clearCart 
  } = useCart();
  
  const [elementorData, setElementorData] = useState(null);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [productVariations, setProductVariations] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loadingVariations, setLoadingVariations] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showFilters, setShowFilters] = useState(true);
  const [showCart, setShowCart] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  // 🔥 NUEVO: Estados para la búsqueda
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchCategoryResults, setSearchCategoryResults] = useState([]);

  // refs para el carrito, búsqueda y botones
  const cartRef = useRef(null);
  const cartButtonRef = useRef(null);
  const searchRef = useRef(null);
  const searchButtonRef = useRef(null);

  const CONSUMER_KEY = 'ck_10a7f64bb813e5c80da979e6c7aec6d878caa883';
  const CONSUMER_SECRET = 'cs_ca1236282d5689c22bb93e0122c5650937500cee';

  // 🔥 FUNCIÓN PARA MOSTRAR NOTIFICACIÓN TOAST
  const showNotification = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 4000);
  };

  // 🔥 NUEVO: Efecto para cerrar búsqueda y carrito al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Cerrar búsqueda si se hace click fuera
      if (showSearch && 
          searchRef.current && 
          !searchRef.current.contains(event.target) &&
          searchButtonRef.current && 
          !searchButtonRef.current.contains(event.target)) {
        setShowSearch(false);
      }
      
      // Cerrar carrito si se hace click fuera
      if (showCart && 
          cartRef.current && 
          !cartRef.current.contains(event.target) &&
          cartButtonRef.current && 
          !cartButtonRef.current.contains(event.target)) {
        setShowCart(false);
      }
    };
    
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showCart, showSearch]);

  // 🔥 NUEVO: Función para buscar productos Y categorías
  const handleSearch = (term) => {
    setSearchTerm(term);
    
    if (term.trim() === '') {
      setSearchResults([]);
      setSearchCategoryResults([]);
      return;
    }
    
    // Buscar productos
    const filteredProducts = products.filter(product => 
      product.name.toLowerCase().includes(term.toLowerCase()) ||
      (product.sku && product.sku.toLowerCase().includes(term.toLowerCase()))
    );
    
    // Buscar categorías
    const filteredCategories = categories.filter(category => 
      category.name.toLowerCase().includes(term.toLowerCase())
    );
    
    setSearchResults(filteredProducts);
    setSearchCategoryResults(filteredCategories);
  };

  // 🔥 NUEVO: Función para ir a la página del producto desde la búsqueda
  const goToProductFromSearch = (productId) => {
    setShowSearch(false);
    setSearchTerm('');
    setSearchResults([]);
    setSearchCategoryResults([]);
    navigate(`/producto/${productId}`);
  };

  // 🔥 NUEVO: Función para ir a la página de categoría desde la búsqueda
  const goToCategoryPage = (categoryId, categoryName) => {
    setShowSearch(false);
    setSearchTerm('');
    setSearchResults([]);
    setSearchCategoryResults([]);
    // Navegar a la página de categoría con parámetros
    navigate(`/categoria/${categoryId}`, { 
      state: { 
        categoryName: categoryName,
        fromSearch: true 
      }
    });
  };

  // 🔥 NUEVO: Componente de búsqueda MEJORADO con categorías
  const renderSearchDropdown = () => {
    if (!showSearch) return null;

    const hasProductResults = searchResults.length > 0;
    const hasCategoryResults = searchCategoryResults.length > 0;
    const hasResults = hasProductResults || hasCategoryResults;

    return (
      <div
        ref={searchRef}
        style={{
          position: 'fixed',
          top: '70px',
          right: showCart ? '420px' : '20px',
          width: '400px',
          background: 'white',
          border: '2px solid #1A3357',
          borderRadius: '12px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          zIndex: 1001,
          maxHeight: '70vh',
          display: 'flex',
          flexDirection: 'column'
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header de búsqueda */}
        <div style={{
          padding: '15px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          background: '#f8f9fa',
          borderRadius: '12px 12px 0 0'
        }}>
          <span style={{ marginRight: '10px', fontSize: '18px' }}>🔍</span>
          <input
            type="text"
            placeholder="Buscar productos o categorías..."
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            style={{
              flex: 1,
              border: 'none',
              background: 'transparent',
              outline: 'none',
              fontSize: '14px',
              color: '#333'
            }}
            autoFocus
          />
          <button
            onClick={() => {
              setShowSearch(false);
              setSearchTerm('');
              setSearchResults([]);
              setSearchCategoryResults([]);
            }}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '16px',
              cursor: 'pointer',
              color: '#666',
              padding: '5px',
              marginLeft: '10px'
            }}
          >
            ✕
          </button>
        </div>

        {/* Resultados de búsqueda */}
        <div style={{ flex: 1, overflowY: 'auto', maxHeight: '400px' }}>
          {!hasResults ? (
            <div style={{
              padding: '30px 20px',
              textAlign: 'center',
              color: '#666'
            }}>
              {searchTerm ? (
                <>
                  <div style={{ fontSize: '36px', marginBottom: '10px' }}>🔍</div>
                  <p style={{ margin: '0 0 10px 0' }}>No se encontraron resultados</p>
                  <p style={{ margin: 0, fontSize: '12px' }}>Intenta con otros términos</p>
                </>
              ) : (
                <>
                  <div style={{ fontSize: '36px', marginBottom: '10px' }}>🔍</div>
                  <p style={{ margin: 0 }}>Escribe para buscar productos o categorías</p>
                </>
              )}
            </div>
          ) : (
            <>
              {/* Resultados de categorías */}
              {hasCategoryResults && (
                <div>
                  <div style={{
                    padding: '10px 15px',
                    background: '#e3f2fd',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#1976d2',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    📁 CATEGORÍAS ({searchCategoryResults.length})
                  </div>
                  {searchCategoryResults.map(category => (
                    <div 
                      key={category.id} 
                      style={{
                        padding: '12px 15px',
                        borderBottom: '1px solid #f8f9fa',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        cursor: 'pointer',
                        transition: 'background 0.2s ease'
                      }}
                      onClick={() => goToCategoryPage(category.id, category.name)}
                      onMouseEnter={(e) => {
                        e.target.style.background = '#f0f7ff';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = 'white';
                      }}
                    >
                      <div style={{
                        width: '32px',
                        height: '32px',
                        background: '#2196f3',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold'
                      }}>
                        📁
                      </div>
                      <div style={{ flex: 1 }}>
                        <h4 style={{
                          margin: '0 0 4px 0',
                          fontSize: '13px',
                          fontWeight: '600',
                          color: '#333'
                        }}>
                          {category.name}
                        </h4>
                        <p style={{
                          margin: 0,
                          fontSize: '11px',
                          color: '#666'
                        }}>
                          {category.count} producto{category.count !== 1 ? 's' : ''}
                        </p>
                      </div>
                      <span style={{
                        fontSize: '12px',
                        color: '#2196f3',
                        fontWeight: '600'
                      }}>
                        Ver categoría →
                      </span>
                    </div>
                  ))}
                </div>
              )}

              {/* Resultados de productos */}
              {hasProductResults && (
                <div>
                  <div style={{
                    padding: '10px 15px',
                    background: '#f3e5f5',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#7b1fa2',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    borderTop: hasCategoryResults ? '1px solid #e0e0e0' : 'none'
                  }}>
                    🏍️ PRODUCTOS ({searchResults.length})
                  </div>
                  {searchResults.map(product => {
                    const priceInfo = getPriceRange(product);
                    const mainImage = product.images && product.images[0];
                    
                    return (
                      <div 
                        key={product.id} 
                        style={{
                          padding: '12px 15px',
                          borderBottom: '1px solid #f0f0f0',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          cursor: 'pointer',
                          transition: 'background 0.2s ease'
                        }}
                        onClick={() => goToProductFromSearch(product.id)}
                        onMouseEnter={(e) => {
                          e.target.style.background = '#f8f9fa';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = 'white';
                        }}
                      >
                        {mainImage ? (
                          <img
                            src={mainImage.src}
                            alt={mainImage.alt || product.name}
                            style={{
                              width: '40px',
                              height: '40px',
                              objectFit: 'cover',
                              borderRadius: '6px'
                            }}
                          />
                        ) : (
                          <div style={{
                            width: '40px',
                            height: '40px',
                            background: '#f5f5f5',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px',
                            color: '#ccc'
                          }}>
                            🏍️
                          </div>
                        )}
                        <div style={{ flex: 1 }}>
                          <h4 style={{
                            margin: '0 0 4px 0',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#333'
                          }}>
                            {product.name}
                          </h4>
                          <p style={{
                            margin: 0,
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color: priceInfo.isSale ? '#e91e63' : '#2196f3'
                          }}>
                            {priceInfo.price}
                          </p>
                        </div>
                        <span style={{
                          fontSize: '12px',
                          color: product.stock_status === 'instock' ? '#4caf50' : '#f44336'
                        }}>
                          {product.stock_status === 'instock' ? '✅' : '❌'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}
        </div>

        {/* Footer de búsqueda */}
        {hasResults && (
          <div style={{
            padding: '12px 15px',
            borderTop: '1px solid #f0f0f0',
            background: '#f8f9fa',
            borderRadius: '0 0 12px 12px',
            fontSize: '12px',
            color: '#666',
            textAlign: 'center'
          }}>
            {searchCategoryResults.length > 0 && `${searchCategoryResults.length} categoría${searchCategoryResults.length !== 1 ? 's' : ''}`}
            {searchCategoryResults.length > 0 && searchResults.length > 0 && ' • '}
            {searchResults.length > 0 && `${searchResults.length} producto${searchResults.length !== 1 ? 's' : ''}`}
            {' encontrado'}{(searchCategoryResults.length + searchResults.length) !== 1 ? 's' : ''}
          </div>
        )}
      </div>
    );
  };

  // 🔥 COMPONENTE TOAST INTEGRADO
  const ToastNotification = () => {
    if (!showToast) return null;

    const messageLines = toastMessage.split('\n');

    return (
      <div style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: 'linear-gradient(135deg, #4caf50, #45a049)',
        color: 'white',
        padding: '15px 20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'flex-start',
        gap: '10px',
        minWidth: '300px',
        maxWidth: '400px',
        animation: 'slideInRight 0.3s ease, fadeOut 0.3s ease 3.7s forwards',
        borderLeft: '4px solid #2e7d32'
      }}>
        <span style={{ fontSize: '18px', marginTop: '2px' }}>✅</span>
        <div style={{ flex: 1 }}>
          {messageLines.map((line, index) => (
            <div 
              key={index} 
              style={{ 
                fontWeight: index === 0 ? '600' : '400',
                fontSize: index === 0 ? '14px' : '12px',
                lineHeight: '1.4',
                marginBottom: index === 0 && messageLines.length > 1 ? '4px' : '0',
                opacity: index === 0 ? 1 : 0.9
              }}
            >
              {line}
            </div>
          ))}
        </div>
        <button
          onClick={() => setShowToast(false)}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '16px',
            cursor: 'pointer',
            marginLeft: 'auto',
            flexShrink: 0,
            padding: '0',
            minWidth: '20px'
          }}
        >
          ✕
        </button>
        
        {/* Estilos de animación */}
        <style>
          {`
            @keyframes slideInRight {
              from {
                transform: translateX(100%);
                opacity: 0;
              }
              to {
                transform: translateX(0);
                opacity: 1;
              }
            }
            @keyframes fadeOut {
              to {
                opacity: 0;
                transform: translateX(100%);
              }
            }
          `}
        </style>
      </div>
    );
  };

  const renderCartDropdown = () => {
    if (!showCart) return null;
    const totalPrice = cart.reduce((total, item) => {
      const price = item.sale_price || item.price;
      return total + (price * item.quantity);
    }, 0);

    return (
      <div
        ref={cartRef}
        style={{
          position: 'fixed',
          top: '70px',
          right: '20px',
          width: '380px',
          background: 'white',
          border: '2px solid #1A3357',
          borderRadius: '12px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          zIndex: 1000,
          maxHeight: '70vh',
          display: 'flex',
          flexDirection: 'column'
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header del carrito */}
        <div style={{
          padding: '20px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: '#f8f9fa',
          borderRadius: '12px 12px 0 0'
        }}>
          <h3 style={{ margin: 0, color: '#333', fontSize: '18px', fontWeight: '600' }}>
            🛒 Mi Carrito ({cartCount} {cartCount === 1 ? 'producto' : 'productos'})
          </h3>
          <button
            onClick={e => {
              e.stopPropagation();
              setShowCart(false);
            }}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#666',
              padding: '5px'
            }}
          >
            ✕
          </button>
        </div>
        {/* Lista de productos */}
        <div style={{ flex: 1, overflowY: 'auto', maxHeight: '400px' }}>
          {cart.length === 0 ? (
            <div style={{
              padding: '40px 20px',
              textAlign: 'center',
              color: '#666'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>🛒</div>
              <p style={{ margin: 0 }}>Tu carrito está vacío</p>
            </div>
          ) : (
            cart.map(item => (
              <div key={item.id} style={{
                padding: '15px',
                borderBottom: '1px solid #f0f0f0',
                display: 'flex',
                alignItems: 'center',
                gap: '15px'
              }}>
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.name}
                    style={{
                      width: '60px',
                      height: '60px',
                      objectFit: 'cover',
                      borderRadius: '8px'
                    }}
                  />
                )}
                <div style={{ flex: 1 }}>
                  <h4 style={{
                    margin: '0 0 5px 0',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#333'
                  }}>
                    {item.name}
                  </h4>
                  
                  {/* 🔥 MOSTRAR ATRIBUTOS SI EXISTEN */}
                  {item.attributes && item.attributes.length > 0 && (
                    <div style={{ marginBottom: '8px' }}>
                      {item.attributes.map((attr, index) => (
                        <div key={index} style={{
                          fontSize: '11px',
                          color: '#666',
                          background: '#f5f5f5',
                          padding: '2px 6px',
                          borderRadius: '3px',
                          display: 'inline-block',
                          marginRight: '5px',
                          marginBottom: '2px'
                        }}>
                          <strong>{attr.name}:</strong> {attr.option}
                        </div>
                      ))}
                    </div>
                  )}
                  
                  <p style={{
                    margin: '0 0 8px 0',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: item.sale_price ? '#e91e63' : '#2196f3'
                  }}>
                    {(item.sale_price || item.price).toFixed(2)} €
                    {item.sale_price && (
                      <span style={{
                        fontSize: '12px',
                        color: '#999',
                        textDecoration: 'line-through',
                        marginLeft: '8px'
                      }}>
                        {item.regular_price.toFixed(2)} €
                      </span>
                    )}
                  </p>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}>
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        decreaseQuantity(item.id);
                      }}
                      style={{
                        width: '30px',
                        height: '30px',
                        background: '#ff6b6b',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      -
                    </button>
                    <span style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      minWidth: '30px',
                      textAlign: 'center',
                      padding: '5px 10px',
                      background: '#f5f5f5',
                      borderRadius: '4px'
                    }}>
                      {item.quantity}
                    </span>
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        increaseQuantity(item.id);
                      }}
                      style={{
                        width: '30px',
                        height: '30px',
                        background: '#4caf50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      +
                    </button>
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        removeFromCart(item.id);
                      }}
                      style={{
                        marginLeft: 'auto',
                        background: '#ff4444',
                        color: 'white',
                        border: 'none',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px'
                      }}
                    >
                      🗑️ Eliminar
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        {/* Footer del carrito */}
        {cart.length > 0 && (
          <div style={{
            padding: '20px',
            borderTop: '1px solid #f0f0f0',
            background: '#f8f9fa',
            borderRadius: '0 0 12px 12px'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              <span>Total:</span>
              <span style={{ color: '#2196f3' }}>{totalPrice.toFixed(2)} €</span>
            </div>
            <button
              onClick={e => {
                e.stopPropagation();
                setShowCart(false);
                navigate('/carrito');
              }}
              style={{
                width: '100%',
                background: '#1A3357',
                color: 'white',
                border: 'none',
                padding: '12px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              Ir al Carrito
            </button>
            <button
              onClick={e => {
               e.stopPropagation();
                clearCart();
                setShowCart(false);
              }}
              style={{
                width: '100%',
                background: 'transparent',
                color: '#ff4444',
                border: '2px solid #ff4444',
                padding: '10px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold',
                marginTop: '10px'
              }}
            >
              🗑️ Vaciar Carrito
            </button>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setElementorData(plantillaTienda);
        
        const CATEGORIES_URL = `https://demo.iconestudio.es/wp-json/wc/v3/products/categories?per_page=100&consumer_key=${CONSUMER_KEY}&consumer_secret=${CONSUMER_SECRET}`;
        const categoriesResponse = await fetch(CATEGORIES_URL);
        
        if (!categoriesResponse.ok) {
          throw new Error(`Error HTTP categorías: ${categoriesResponse.status}`);
        }

        const categoriesData = await categoriesResponse.json();
        setCategories(categoriesData.filter(cat => cat.count > 0));

        const PRODUCTS_URL = `https://demo.iconestudio.es/wp-json/wc/v3/products?per_page=100&consumer_key=${CONSUMER_KEY}&consumer_secret=${CONSUMER_SECRET}`;
        const productsResponse = await fetch(PRODUCTS_URL);
        
        if (!productsResponse.ok) {
          throw new Error(`Error HTTP productos: ${productsResponse.status}`);
        }

        const productsData = await productsResponse.json();
        const publishedProducts = productsData.filter(product => product.status === 'publish');
        
        setProducts(publishedProducts);
        fetchVariationsForVariableProducts(publishedProducts);
        setLoading(false);

      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // 🔥 FUNCIÓN PARA FILTRAR PRODUCTOS POR CATEGORÍAS SELECCIONADAS
  const getFilteredProducts = () => {
    if (selectedCategories.length === 0) {
      return products;
    }

    return products.filter(product => {
      if (!product.categories || !Array.isArray(product.categories)) return false;
      
      const productCategoryIds = product.categories.map(cat => cat.id || cat);
      return selectedCategories.some(selectedCatId => 
        productCategoryIds.includes(selectedCatId)
      );
    });
  };

  // 🔥 FUNCIÓN PARA MANEJAR SELECCIÓN/DESELECCIÓN DE CATEGORÍAS
  const handleCategoryToggle = (categoryId) => {
    setSelectedCategories(prev => {
      if (prev.includes(categoryId)) {
        return prev.filter(id => id !== categoryId);
      } else {
        return [...prev, categoryId];
      }
    });
  };

  // 🔥 FUNCIÓN PARA SELECCIONAR/DESELECCIONAR TODAS LAS CATEGORÍAS
  const handleSelectAllCategories = () => {
    if (selectedCategories.length === categories.length) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(categories.map(cat => cat.id));
    }
  };

  // 🔥 COMPONENTE DE FILTRO DE CATEGORÍAS MEJORADO
  const renderCategoryFilter = () => {
    return (
      <div style={{
        background: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '20px',
        marginRight: '10px',
        width: '280px',
        flexShrink: 0,
        position: 'sticky',
        top: '20px',
        alignSelf: 'flex-start',
        maxHeight: 'calc(100vh - 40px)',
        overflowY: 'auto',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        {/* Header del filtro */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
          cursor: 'pointer',
          paddingBottom: '15px',
          borderBottom: '2px solid #f0f0f0'
        }}
        onClick={() => setShowFilters(!showFilters)}>
          <h3 style={{ 
            margin: 0, 
            color: '#333', 
            fontSize: '18px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center'
          }}>
            <span style={{ marginRight: '10px', fontSize: '20px' }}>🔍</span>
            Filtro
          </h3>
          <span style={{ 
            fontSize: '16px', 
            color: '#666',
            transform: showFilters ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease'
          }}>
            ▼
          </span>
        </div>

        {showFilters && (
          <>
            {/* Selector todas/ninguna */}
            <div style={{ 
              marginBottom: '20px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <button 
                onClick={handleSelectAllCategories}
                style={{
                  background: selectedCategories.length === categories.length ? '#2196f3' : 'transparent',
                  color: selectedCategories.length === categories.length ? 'white' : '#2196f3',
                  border: '1px solid #2196f3',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '500',
                  transition: 'all 0.3s ease'
                }}
              >
                {selectedCategories.length === categories.length ? 'Deseleccionar todas' : 'Seleccionar todas'}
              </button>
              <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>
                {selectedCategories.length} de {categories.length} seleccionadas
              </span>
            </div>

            {/* Título Category */}
            <div style={{ 
              color: '#333', 
              fontSize: '14px', 
              fontWeight: '600',
              marginBottom: '15px',
              paddingBottom: '10px',
              borderBottom: '1px solid #eee',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Category
            </div>

            {/* Lista de categorías */}
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {categories.map(category => (
                <label key={category.id} style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 0',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f8f9fa',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f8f9fa';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}>
                  <input
                    type="checkbox"
                    checked={selectedCategories.includes(category.id)}
                    onChange={() => handleCategoryToggle(category.id)}
                    style={{
                      marginRight: '12px',
                      width: '18px',
                      height: '18px',
                      cursor: 'pointer',
                      accentColor: '#2196f3'
                    }}
                  />
                  <span style={{ 
                    flex: 1,
                    color: selectedCategories.includes(category.id) ? '#2196f3' : '#555',
                    fontSize: '14px',
                    fontWeight: selectedCategories.includes(category.id) ? '500' : '400'
                  }}>
                    {category.name}
                  </span>
                  <span style={{
                    background: selectedCategories.includes(category.id) ? '#2196f3' : '#e9ecef',
                    color: selectedCategories.includes(category.id) ? 'white' : '#666',
                    padding: '4px 10px',
                    borderRadius: '12px',
                    fontSize: '11px',
                    fontWeight: '600',
                    minWidth: '30px',
                    textAlign: 'center'
                  }}>
                    {category.count}
                  </span>
                </label>
              ))}
            </div>

            {/* Contadores */}
            {selectedCategories.length > 0 && (
              <div style={{
                marginTop: '20px',
                padding: '15px',
                background: '#e3f2fd',
                borderRadius: '6px',
                fontSize: '13px',
                color: '#1976d2',
                fontWeight: '500'
              }}>
                📊 Mostrando {getFilteredProducts().length} productos de {selectedCategories.length} categoría(s)
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  // 🔥 FUNCIONES ORIGINALES CORREGIDAS
  const fetchVariationsForVariableProducts = async (productsList) => {
    const variableProducts = productsList.filter(product => product.type === 'variable');
    
    for (const product of variableProducts) {
      try {
        setLoadingVariations(prev => ({ ...prev, [product.id]: true }));
        
        const VARIATIONS_URL = `https://demo.iconestudio.es/wp-json/wc/v3/products/${product.id}/variations?consumer_key=${CONSUMER_KEY}&consumer_secret=${CONSUMER_SECRET}`;
        const response = await fetch(VARIATIONS_URL);
        
        if (response.ok) {
          const variations = await response.json();
          setProductVariations(prev => ({
            ...prev,
            [product.id]: variations
          }));
        }
      } catch (err) {
        console.error(`Error obteniendo variaciones para ${product.name}:`, err);
      } finally {
        setLoadingVariations(prev => ({ ...prev, [product.id]: false }));
      }
    }
  };

  const isOnSale = (product) => {
    return product.sale_price && product.sale_price !== "" && product.sale_price !== product.regular_price;
  };

  const getPriceRange = (product) => {
    if (product.type !== 'variable') {
      return isOnSale(product) ? 
        { price: `${product.sale_price} €`, original: `${product.regular_price} €`, isSale: true } : 
        { price: `${product.price} €`, isSale: false };
    }

    const variations = productVariations[product.id];
    if (!variations || variations.length === 0) {
      return { price: "Consultar precio", isSale: false };
    }

    const prices = variations.map(v => parseFloat(v.price)).filter(price => !isNaN(price));
    if (prices.length === 0) {
      return { price: "Consultar precio", isSale: false };
    }

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);

    const hasSale = variations.some(v => v.sale_price && v.sale_price !== "" && v.sale_price !== v.regular_price);

    if (minPrice === maxPrice) {
      return { price: `${minPrice.toFixed(2)} €`, isSale: hasSale };
    } else {
      return { 
        price: `${minPrice.toFixed(2)} € - ${maxPrice.toFixed(2)} €`, 
        isSale: hasSale 
      };
    }
  };

  const sortProducts = (products) => {
    return [...products].sort((a, b) => {
      const priceA = getPriceRange(a);
      const priceB = getPriceRange(b);

      if (priceA.isSale && !priceB.isSale) return -1;
      if (!priceA.isSale && priceB.isSale) return 1;

      const hasRangeA = priceA.price.includes(" - ");
      const hasRangeB = priceB.price.includes(" - ");

      if (hasRangeA && !hasRangeB) return -1;
      if (!hasRangeA && hasRangeB) return 1;

      return 0;
    });
  };

  const getProductCategories = (product) => {
    if (!product.categories || !Array.isArray(product.categories)) return [];
    
    return product.categories.map(cat => {
      const category = categories.find(c => c.id === (cat.id || cat));
      return category ? { id: category.id, name: category.name } : null;
    }).filter(Boolean);
  };

  // Estilos base para el contenedor gris
  const styles = {
    container: {
      fontFamily: "'Montserrat', 'Segoe UI', sans-serif",
      maxWidth: 'auto',
      margin: '0 auto',
      padding: '20px'
    },
    loading: {
      textAlign: 'center',
      padding: '60px 20px'
    },
    section: {
      width: '100%',
      position: 'relative'
    },
    sectionStretched: {
      width: '100vw',
      marginLeft: 'calc(-50vw + 50%)'
    },
    containerFlex: {
      flexWrap: 'wrap',
      display: 'flex',
      margin: '0 auto',
    },
    column: {
      padding: '10px',
      boxSizing: 'border-box'
    },
    widget: {
      margin: '10px 0'
    }
  };

  const parseStyles = (settings) => {
    if (!settings) return {};
    
    const elementorStyles = {};
    
    if (settings._margin) {
      elementorStyles.margin = `${settings._margin.top}% ${settings._margin.right}% ${settings._margin.bottom}% ${settings._margin.left}%`;
    }
    
    if (settings._padding) {
      elementorStyles.padding = `${settings._padding.top}% ${settings._padding.right}% ${settings._padding.bottom}% ${settings._margin.left}%`;
    }
    
    if (settings.background_color) {
      elementorStyles.backgroundColor = settings.background_color;
    }
    
    if (settings.align) {
      elementorStyles.textAlign = settings.align;
    }
    
    if (settings.background_background === 'gradient') {
      elementorStyles.background = `radial-gradient(at ${settings.background_gradient_position || 'center'}, #f8f9fa, #e9ecef)`;
    }

    return elementorStyles;
  };

  // 🔥 FUNCIÓN MODIFICADA: Renderizar productos CON nuestro filtro personalizado
  const renderWooCommerceProducts = (settings) => {
    const filteredProducts = getFilteredProducts();
    
    // 🔥 NUEVA FUNCIÓN: Manejar clic en producto
    const handleProductClick = (productId) => {
      navigate(`/producto/${productId}`);
    };

    // 🔥 FUNCIÓN PARA MANEJAR AÑADIR AL CARRITO DESDE LA TIENDA
    const handleAddToCartFromStore = (product, e) => {
      e.stopPropagation();
      
      let productToAdd;
      let productName = product.name;
      let attributesText = '';
      
      if (product.type === 'variable') {
        // Para productos variables en la tienda, mostrar mensaje de redirección
        showNotification(`🔄 Redirigiendo a "${productName}" para seleccionar opciones`);
        setTimeout(() => {
          navigate(`/producto/${product.id}`);
        }, 2000);
        return;
      } else {
        // Producto simple
        productToAdd = {
          id: product.id,
          name: product.name,
          price: parseFloat(product.price),
          sale_price: product.sale_price ? parseFloat(product.sale_price) : null,
          regular_price: parseFloat(product.regular_price),
          image: product.images && product.images[0] ? product.images[0].src : null,
          quantity: 1,
          stock_status: product.stock_status,
          sku: product.sku || '',
          categories: product.categories || [],
          type: 'simple',
          attributes: []
        };
      }

      addToCart(productToAdd);
      
      // 🔥 MOSTRAR NOTIFICACIÓN CON NOMBRE DEL PRODUCTO
      let notificationMessage = `Se añadió "${productName}" al carrito`;
      if (attributesText) {
        notificationMessage += `\n${attributesText}`;
      }
      showNotification(notificationMessage);
    };

    if (filteredProducts.length === 0 && products.length > 0) {
      return (
        <div style={{...styles.widget, padding: '40px', textAlign: 'center', background: '#f8f9fa', borderRadius: '8px'}}>
          <h3>No hay productos en las categorías seleccionadas</h3>
          <p>Prueba a seleccionar otras categorías</p>
          <button 
            onClick={() => setSelectedCategories([])}
            style={{
              background: '#2196f3',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              marginTop: '10px'
            }}
          >
            Mostrar todos los productos
          </button>
        </div>
      );
    }

    if (products.length === 0) {
      return (
        <div style={{...styles.widget, padding: '40px', textAlign: 'center', background: '#f8f9fa', borderRadius: '8px'}}>
          <p>Cargando productos...</p>
        </div>
      );
    }

    const sortedProducts = sortProducts(filteredProducts);

    return (
      <div style={{...styles.widget, ...parseStyles(settings)}} data-products-section>
        {/* 🔥 LAYOUT DE DOS COLUMNAS: Filtro personalizado a la izquierda, productos a la derecha */}
        <div style={{
          display: 'flex',
          gap: '30px',
          alignItems: 'flex-start'
        }}>
          {/* Columna izquierda: NUESTRO FILTRO PERSONALIZADO */}
          {renderCategoryFilter()}

          {/* Columna derecha: Productos */}
          <div style={{ flex: 1 }}>
            {/* Título de la sección de productos */}
            <div style={{textAlign: 'center', marginBottom: '30px'}}>
              {selectedCategories.length > 0 && (
                <div style={{
                  background: '#e3f2fd',
                  padding: '15px',
                  borderRadius: '8px',
                  marginBottom: '15px'
                }}>
                  <h3 style={{ margin: '0 0 10px 0', color: '#1976d2' }}>
                    📁 Filtrado por categoría(s)
                  </h3>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
                    {selectedCategories.map(catId => {
                      const category = categories.find(c => c.id === catId);
                      return category ? (
                        <span key={category.id} style={{
                          background: '#2196f3',
                          color: 'white',
                          padding: '6px 12px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: '600'
                        }}>
                          {category.name}
                        </span>
                      ) : null;
                    })}
                  </div>
                  <button 
                    onClick={() => setSelectedCategories([])}
                    style={{
                      background: 'transparent',
                      color: '#1976d2',
                      border: '1px solid #1976d2',
                      padding: '5px 15px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      marginTop: '10px'
                    }}
                  >
                    Limpiar filtros
                  </button>
                </div>
              )}
              <p style={{ color: '#666', marginTop: '10px' }}>
                {filteredProducts.length} producto{filteredProducts.length !== 1 ? 's' : ''} encontrado{filteredProducts.length !== 1 ? 's' : ''}
              </p>
            </div>

            {/* Grid de productos */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
              gap: '25px',
              width: '100%',
            }}>
              {sortedProducts.map(product => {
                const priceInfo = getPriceRange(product);
                const mainImage = product.images && product.images[0];
                const isLoadingVariations = loadingVariations[product.id];
                const variations = productVariations[product.id];
                const productCategories = getProductCategories(product);
                
                return (
                  <div 
                    key={product.id} 
                    style={{
                      background: 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: '12px',
                      padding: '20px',
                      textAlign: 'center',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onClick={() => handleProductClick(product.id)}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-5px)';
                      e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    
                    {/* Imagen del producto */}
                    {mainImage ? (
                      <img 
                        src={mainImage.src} 
                        alt={mainImage.alt || product.name}
                        style={{
                          width: '100%',
                          height: '200px',
                          objectFit: 'contain',
                          borderRadius: '8px',
                          marginBottom: '15px',
                          background: '#f8f9fa'
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '100%',
                        height: '200px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '48px',
                        color: '#ccc',
                        marginBottom: '15px'
                      }}>
                        🏍️
                      </div>
                    )}

                    {/* Categorías del producto */}
                    {productCategories.length > 0 && (
                      <div style={{
                        marginBottom: '10px',
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        gap: '5px'
                      }}>
                        {productCategories.slice(0, 2).map((category, index) => (
                          <span key={index} style={{
                            background: selectedCategories.includes(category.id) ? '#2196f3' : '#e3f2fd',
                            color: selectedCategories.includes(category.id) ? 'white' : '#1976d2',
                            padding: '2px 8px',
                            borderRadius: '12px',
                            fontSize: '10px',
                            fontWeight: 'bold'
                          }}>
                            {category.name}
                          </span>
                        ))}
                        {productCategories.length > 2 && (
                          <span style={{
                            background: '#f5f5f5',
                            color: '#666',
                            padding: '2px 8px',
                            borderRadius: '12px',
                            fontSize: '10px'
                          }}>
                            +{productCategories.length - 2}
                          </span>
                        )}
                      </div>
                    )}

                    {/* Nombre del producto */}
                    <h3 style={{
                      fontFamily: 'Montserrat',
                      fontWeight: '600',
                      fontSize: '16px',
                      margin: '0 0 10px 0',
                      color: '#333',
                      minHeight: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      {product.name}
                    </h3>

                    {/* Precio */}
                    <div style={{ marginBottom: '15px' }}>
                      <span style={{
                        color: priceInfo.isSale ? '#e91e63' : '#2196f3',
                        fontWeight: 'bold',
                        fontSize: '20px',
                        display: 'block'
                      }}>
                        {priceInfo.price}
                      </span>
                      {priceInfo.original && (
                        <span style={{
                          color: '#999',
                          textDecoration: 'line-through',
                          fontSize: '16px',
                          marginRight: '10px'
                        }}>
                          {priceInfo.original}
                        </span>
                      )}
                      {priceInfo.isSale && (
                        <span style={{
                          display: 'inline-block',
                          background: '#ff1744',
                          color: 'white',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '12px',
                          marginTop: '5px'
                        }}>
                          🎉 OFERTA
                        </span>
                      )}
                      
                      {/* Información de variaciones */}
                      {product.type === 'variable' && (
                        <div style={{ marginTop: '5px', fontSize: '0.8em', color: '#666' }}>
                          {isLoadingVariations ? (
                            <span>🔄 Cargando variaciones...</span>
                          ) : variations && variations.length > 0 ? (
                            <span>{variations.length} opciones disponibles</span>
                          ) : (
                            <span>Producto variable</span>
                          )}
                        </div>
                      )}
                    </div>

                    {/* 🔥 BOTÓN MODIFICADO: Usar la nueva función de añadir al carrito */}
                    <button 
                      onClick={(e) => handleAddToCartFromStore(product, e)}
                      style={{
                        background: '#1A3357',
                        color: '#FFFFFF',
                        border: 'none',
                        padding: '12px 24px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        width: '100%',
                        fontSize: '14px',
                        fontWeight: '600',
                        transition: 'background 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = '#3496D2';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = '#1A3357';
                      }}
                    >
                      {product.type === 'variable' ? 'Seleccionar opciones' : 'Añadir al carrito'}
                    </button>

                    {/* Stock status */}
                    <div style={{
                      marginTop: '10px',
                      fontSize: '12px',
                      color: product.stock_status === 'instock' ? '#4caf50' : '#f44336'
                    }}>
                      {product.stock_status === 'instock' ? '✅ En stock' : '❌ Sin stock'}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Contador final */}
            <div style={{
              textAlign: 'center',
              marginTop: '30px',
              padding: '15px',
              background: '#f8f9fa',
              borderRadius: '8px'
            }}>
              <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                Mostrando <strong>{filteredProducts.length}</strong> de <strong>{products.length}</strong> productos • 
                <strong style={{color: '#ff1744', marginLeft: '10px'}}>
                  {filteredProducts.filter(p => getPriceRange(p).isSale).length} en oferta
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 🔥 FUNCIÓN RENDER WIDGET: Actualizado para mostrar botón de búsqueda y carrito
  const renderWidget = (widget, index) => {
    const { widgetType, settings = {}, id } = widget;
    const key = `${id || widgetType}-${index}`;
    const widgetRenderers = {
      'hfe-cart': () => (
        <div style={{ ...styles.widget, ...parseStyles(settings), textAlign: settings.align || 'right', display: 'flex', alignItems: 'center', gap: '15px' }}>
          {/* 🔥 NUEVO: Botón de búsqueda */}
          <div
            ref={searchButtonRef}
            onClick={e => {
              e.stopPropagation();
              setShowSearch(!showSearch);
              setShowCart(false);
            }}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600',
              padding: '10px 15px',
              borderRadius: '6px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={e => {
              e.target.style.background = '#f0f0f0';
            }}
            onMouseLeave={e => {
              e.target.style.background = 'transparent';
            }}
          >
            <span style={{ fontSize: '20px', marginRight: '8px' }}>
              🔍
            </span>
            Buscar
          </div>

          {/* Botón del carrito existente */}
          <div
            ref={cartButtonRef}
            onClick={e => {
              e.stopPropagation();
              setShowCart(!showCart);
              setShowSearch(false);
            }}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: settings.toggle_button_typography_font_size?.size + 'px' || '17px',
              fontWeight: settings.toggle_button_typography_font_weight || '600',
              padding: '10px 15px',
              borderRadius: '6px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={e => {
              e.target.style.background = '#f0f0f0';
            }}
            onMouseLeave={e => {
              e.target.style.background = 'transparent';
            }}
          >
            <span style={{ fontSize: settings.toggle_icon_size?.size + 'px' || '31px', marginRight: '10px' }}>
              🛍️
            </span>
            Carrito ({cartCount})
            {showCart && <span style={{ marginLeft: '10px', fontSize: '12px' }}>▼</span>}
          </div>
        </div>
      ),
    };
    const renderer = widgetRenderers[widgetType];
    return renderer ? <div key={key}>{renderer()}</div> : null;
  };

  // 🔥 FUNCIÓN RENDER ELEMENT: ELIMINAR COMPLETAMENTE LOS FILTROS DEL JSON
  const renderElement = (element, index) => {
    if (!element) return null;

    const { elType, settings = {}, elements = [], id, widgetType } = element;
    const key = `${id || elType}-${index}`;

    // 🔥 ELIMINAR COMPLETAMENTE CUALQUIER ELEMENTO QUE SEA UN FILTRO
    if (widgetType === 'wc-categories' || 
        widgetType === 'filters' ||
        (settings.text && settings.text.includes('Filtro')) ||
        (settings.title && settings.title.includes('Filtro'))) {
      return null;
    }

    switch (elType) {
      case 'section':
        const isStretched = settings.stretch_section === 'section-stretched';
        const sectionStyle = {
          ...styles.section,
          ...(isStretched ? styles.sectionStretched : {}),
          ...parseStyles(settings)
        };
        
        return (
          <section key={key} style={sectionStyle}>
            <div style={styles.containerFlex}>
              {elements.map((child, idx) => renderElement(child, idx))}
            </div>
          </section>
        );

      case 'column':
        const columnWidth = settings._inline_size || settings._column_size || 100;
        const columnStyle = {
          ...styles.column,
          ...parseStyles(settings),
          flex: `0 0 ${columnWidth}%`,
          maxWidth: `${columnWidth}%`
        };
        
        return (
          <div key={key} style={columnStyle}>
            {elements.map((child, idx) => renderElement(child, idx))}
          </div>
        );

      case 'widget':
        // 🔥 EXCLUIR WIDGETS DE PRODUCTOS WOOCOMMERCE - LOS MANEJAMOS POR SEPARADO
        if (widgetType === 'woocommerce-products') {
          return renderWooCommerceProducts(settings);
        }
        
        // Renderizar otros widgets normales
        return renderWidget(element, index);

      default:
        return null;
    }
  };

  if (loading) {
    return (
      <div style={styles.loading}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔄</div>
        <h2>Cargando Tienda v3...</h2>
        <p>Diseño de Elementor + Productos reales de WooCommerce</p>
        <p>Cargando {categories.length} categorías y {products.length} productos...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{background: '#ffe6e6', padding: '30px', borderRadius: '8px', textAlign: 'center', margin: '20px'}}>
        <h2>❌ Error</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* 🔥 NOTIFICACIÓN TOAST */}
      <ToastNotification />
      
      {/* 🔥 NUEVO: Dropdown de búsqueda */}
      {renderSearchDropdown()}
      
      <main>
        {elementorData && elementorData.content.map((element, index) =>
          renderElement(element, index)
        )}
      </main>
      {renderCartDropdown()}
    </div>
  );
};

export default Tiendav3;